import { ErrorResponse } from 'src/app/models/error.model';
import { PaymentService } from './../../../services/payment.service';
import { PaymentFormComponent, PaymentConfig } from './../../generics/payment-form/payment-form.component';
import { PaymentInformation } from './../../../models/payment-information.model';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/services/utils.service';
import { GuarantiesService } from './../../../services/guaranties.service';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-tenants-payment-form',
    templateUrl: './tenants-payment-form.component.html',
    styleUrls: ['./tenants-payment-form.component.scss']
})
export class TenantsPaymentFormComponent implements OnInit {

    warrantyHash: string;

    paymentInformation: PaymentInformation;

    paymentFG = new UntypedFormGroup({
        medio: new UntypedFormControl(undefined, [Validators.required]),
        opcion: new UntypedFormControl(undefined, []),
        comprobantes: new UntypedFormControl([], []),
        token: new UntypedFormControl(undefined, []),
        bin: new UntypedFormControl(undefined, []),
        montoPagado: new UntypedFormControl(undefined, []),
    });

    @ViewChild(PaymentFormComponent, { static: false })
    paymentFormElement: PaymentFormComponent;

    // Link de Mercado Pago recién generado, pendiente de que el operador lo copie o vuelva.
    // Solo se usa cuando quien genera el link es un operador logueado (ver reportPayment()).
    linkGenerado: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private guarantiesService: GuarantiesService,
        private paymentService: PaymentService,
        private utilsService: UtilsService,
        private authService: AuthService,
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            // Mercado Pago redirige a esta URL luego del pago con params extra (collection_id, status, etc.)
            // En ese caso no mostramos el formulario, sino la pantalla de confirmación. Se reenvía
            // el estado y el hash para que "listo" pueda ofrecer reintentar si no se concretó.
            if (params['collection_id'] || params['payment_id']) {
                this.router.navigate(['listo'], {
                    relativeTo: this.route,
                    queryParams: { id: params.id, status: params.status || params['collection_status'] },
                });
                return;
            }
            if (params.id) {
                this.warrantyHash = params.id;
                this.guarantiesService.getPaymentInformation(params.id).subscribe(paymentInformation => {
                    this.paymentInformation = paymentInformation;
                }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener detalles del pago', error.error?.descripcion));
            }
        });
    }

    pay() {
        this.paymentFG.markAllAsTouched();
        if (this.paymentFormElement.isValid() && this.paymentFG.valid) {
            this.reportPayment();
        }
    }

    uploadPaymentProof = (file: File) => {
        return this.paymentService.uploadPaymentProof(this.warrantyHash, file);
    }

    reportPayment() {
        if (this.paymentFG.valid) {
            this.paymentService.reportPayment(this.warrantyHash, this.paymentFG.value as PaymentConfig).subscribe(
                warranty => {
                    const operaciones = warranty.pagos?.principal?.operaciones;
                    const urlPago = operaciones?.length ? operaciones[operaciones.length - 1].urlPago : undefined;
                    if (urlPago && this.authService.getUser()) {
                        // Lo generó un operador (backoffice logueado) desde "Completar manualmente":
                        // se le ofrece copiar el link en vez de redirigirlo a él mismo a Mercado Pago.
                        this.linkGenerado = urlPago;
                    } else if (urlPago) {
                        window.location.href = urlPago;
                    } else {
                        this.router.navigate(['listo'], { relativeTo: this.route });
                    }
                },
                (error: ErrorResponse) => this.utilsService.alert('Error reportando pago', error.error?.descripcion)
            );
        }
    }

    copyLink() {
        navigator.clipboard.writeText(this.linkGenerado).then(() => {
            this.utilsService.alert('Link copiado', 'El link de pago fue copiado al portapapeles.');
        });
    }

    volver() {
        window.close();
    }
}
